import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'asg-spinner-dialog',
    templateUrl: './spinner-dialog.component.html',
    styleUrls: ['./spinner-dialog.component.scss'],
    standalone: true,
    imports: [MatProgressSpinnerModule]
})
export class SpinnerDialogComponent {

  constructor(dialogRef: MatDialogRef<SpinnerDialogComponent>) {
    dialogRef.disableClose = true;
  }
}
